import React from 'react'
import styled, { keyframes } from 'styled-components'

export type OtpInputInlineInputProps = {
  hasError?: boolean
} & React.InputHTMLAttributes<HTMLInputElement> & {
    ref: React.Ref<HTMLInputElement>
  }

export const OtpInputInlineInput: React.FC<OtpInputInlineInputProps> = ({
  hasError,
  ...props
}) => (
  <Root aria-invalid={hasError} aria-checked={props.value !== ''}>
    <Input {...props} />
    <Underline aria-invalid={hasError} aria-disabled={props.disabled} />
  </Root>
)

const Underline = styled.div`
  position: absolute;
  bottom: 6px;
  left: 0;
  right: 0;
  margin: auto;

  width: 16px;
  height: 2px;

  transition: all 0.15s linear;

  &[aria-invalid='true'] {
    background-color: rgba(var(--down-9-rgb), 0.7);
  }
  &[aria-disabled='true'] {
    background-color: transparent;
  }
`

const fade = keyframes`
	from {
    background-color: var(--textA-7);
  }
  to {
    background-color: var(--text-12);
	}
`

const Root = styled.div`
  position: relative;

  border-radius: 10px;
  background: var(--appearanceA-2);
  width: 34px;
  height: 40px;

  border: 1px solid transparent;

  &:focus-within:not([aria-disabled='true']) {
    background: var(--appearanceA-7);
  }

  &[aria-checked='true'] {
    background: var(--appearanceA-7);
    border: 1px solid var(--primary-9);
  }
  &[aria-invalid='true'] {
    border: 1px solid rgba(var(--down-9-rgb), 0.7);
  }

  &:focus-within:not([aria-invalid='true']) {
    & ${Underline} {
      animation-name: ${fade};
      background-color: var(--down-7);
      animation-duration: 1s;
      animation-timing-function: linear;
      animation-iteration-count: infinite;
      animation-direction: alternate;
      animation-play-state: running;
    }
  }
`

const Input = styled.input`
  background: transparent;
  color: var(--text-12);
  padding-top: 2px;

  width: 100%;
  height: 100%;
  text-align: center;
  font-size: 14px;
  font-weight: 600;

  outline: none;
  caret-color: transparent;
  cursor: pointer;
  border: none;

  ::-webkit-outer-spin-button,
  ::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  transition: all 0.15s linear;

  &[disabled] {
    color: var(--text-10);
  }
`
